export const theme = {
  main: "#53e639",
  accent: "#FFFFFF",
  secondary: "#000000",
};
